var ServiceEntryPriority = {
    NONE: { value: 0, color: '#1B1818' },
    CHECK: { value: 1, color: '#810082' },
    MAINTENANCE: { value: 2, color: '#F64583' },
    REPAIR_HIGH: { value: 3, color: '#FC4D0B' },
    REPAIR_MEDIUM: { value: 4, color: '#F5BD0B' },
    REPAIR_LOW: { value: 5, color: '#87C326' },
    CRITICAL: { value: 6, color: '#C70005' },
    getKeys: function () {
        var _this = this;
        return Object.keys(this).filter(function (key) { return typeof _this[key] !== 'function'; });
    },
    getKeyByValue: function (value) {
        var _this = this;
        return Object.keys(this).find(function (key) {
            return _this[key].value === value;
        });
    }
};
export default ServiceEntryPriority;
